import React, { useMemo } from 'react'
import { observer } from 'mobx-react'
import { storeMobx, discountMobx } from 'restaurant'
import { format } from '@dt/fe-utils'
import { modalLayer } from '@utils'
import { Icon } from '@cps'
import { BusinessLicenseModal } from '../../modal'
import './index.scss'

interface IProps {
  onChange: (isFull: boolean) => void;
}

const MenuNoticeFull: React.FC<IProps> = (props) => {
  const { onChange } = props
  const { noticeConfig } = storeMobx.info
  const show = noticeConfig?.showCustom?.content || (noticeConfig?.showMktInfo && discountMobx.activities?.length) || noticeConfig?.showStoreInfo
  const storeSaleTime = format.toSaleTime(storeMobx.info?.saleTime, bo === 'cn' ? '24' : '12')
  const { activities } = discountMobx
  const businessLicensePics = useMemo(() => {
    let pics = []
    try {
      pics = JSON.parse(storeMobx.info?.storeExtInfo?.businessLicensePics) || []
    } catch (error) {
    }
    return pics || []
  }, [storeMobx.info?.storeExtInfo?.businessLicensePics])

  // 门店营业资质
  const handleShowBusinessLicense = () => {
    modalLayer(BusinessLicenseModal, {
      pics: businessLicensePics
    }).then(() => { }, () => { })
  }

  if (!show) return null

  return (
    <div className='menu-notice-full'>
      <div className='menu-notice-header'>
        <div className='menu-notice-fold' onClick={() => onChange(false)}>
          <Icon name='chevron-up' />
        </div>
      </div>
      <div className='menu-notice-content'>
        {storeMobx.info?.noticeConfig?.showCustom?.content && <pre className='menu-notice-full-item'>{storeMobx.info?.noticeConfig?.showCustom?.content}</pre>}
        {storeMobx.info?.noticeConfig?.showMktInfo && activities?.length ? (
          <div className='menu-notice-full-item'>
            <div className='menu-notice-full-title'>{i18n.t('menu.mktInfo')}</div>
            {activities.map(item => <div key={item.activityId}>{item.activityName}</div>)}
          </div>
        ) : null}
        {storeMobx.info?.noticeConfig?.showStoreInfo ? (
          <div className='menu-notice-full-item'>
            <div className='menu-notice-full-title'>{i18n.t('menu.storeInfo')}</div>
            <div>
              {i18n.t('menu.storeInfoAddress')}
              {storeMobx.info?.address}{storeMobx.info?.addressDetails}
            </div>
            {storeMobx.info?.tel && (
              <div>
                {i18n.t('menu.storeInfoTel')}
                {storeMobx.info?.tel}
              </div>
            )}
            {storeSaleTime && (
              <div>
                {i18n.t('menu.storeInfoSaleTime')}
                {storeSaleTime.join(bo === 'cn' ? '；' : ';')}
              </div>
            )}
            {!!businessLicensePics?.length && (
              <a className='to-see-license' onClick={handleShowBusinessLicense}>{i18n.t('store.seeBusinessLicense')}</a>
            )}
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default observer(MenuNoticeFull)
